"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeChartData = exports.buildLegendConfig = exports.resolveColorPalette = exports.clampPointSize = exports.clampSlicePadding = exports.clampUnit = exports.MAX_SLICE_PADDING_DEGREES = exports.LEGEND_EDGE_OFFSET = exports.DEFAULT_ANIMATION_DURATION = exports.MAX_POINT_SIZE = exports.MIN_POINT_SIZE = exports.DEFAULT_POINT_SIZE = exports.FALLBACK_BAR_BORDER_RADIUS = exports.DEFAULT_AREA_OPACITY = exports.DEFAULT_LINE_STROKE_WIDTH = exports.DEFAULT_LINE_SMOOTHNESS = exports.AGENT_CHART_PALETTE = void 0;
const palette_1 = require("./palette");
exports.AGENT_CHART_PALETTE = palette_1.DEFAULT_PALETTE;
exports.DEFAULT_LINE_SMOOTHNESS = 0.32;
exports.DEFAULT_LINE_STROKE_WIDTH = 3;
exports.DEFAULT_AREA_OPACITY = 0.2;
exports.FALLBACK_BAR_BORDER_RADIUS = 4;
exports.DEFAULT_POINT_SIZE = 8;
exports.MIN_POINT_SIZE = 0;
exports.MAX_POINT_SIZE = 28;
exports.DEFAULT_ANIMATION_DURATION = 400;
exports.LEGEND_EDGE_OFFSET = 20;
exports.MAX_SLICE_PADDING_DEGREES = 10;
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
const clampUnit = (value) => {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        return undefined;
    }
    return clamp(value, 0, 1);
};
exports.clampUnit = clampUnit;
const clampSlicePadding = (value) => {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        return undefined;
    }
    return clamp(value, 0, exports.MAX_SLICE_PADDING_DEGREES);
};
exports.clampSlicePadding = clampSlicePadding;
const clampPointSize = (value) => {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        return exports.DEFAULT_POINT_SIZE;
    }
    return clamp(value, exports.MIN_POINT_SIZE, exports.MAX_POINT_SIZE);
};
exports.clampPointSize = clampPointSize;
const resolveColorPalette = (desiredCount, overrides) => {
    const palette = Array.isArray(overrides) && overrides.length > 0 ? overrides : exports.AGENT_CHART_PALETTE;
    if (desiredCount <= palette.length) {
        return palette.slice(0, desiredCount);
    }
    return Array.from({ length: desiredCount }, (_, index) => palette[index % palette.length]);
};
exports.resolveColorPalette = resolveColorPalette;
const buildLegendConfig = (options, defaultVisibility) => {
    var _a, _b;
    const shouldShow = (_a = options.showLegend) !== null && _a !== void 0 ? _a : defaultVisibility;
    if (!shouldShow) {
        return { show: false };
    }
    const legendPosition = (_b = options.legendPosition) !== null && _b !== void 0 ? _b : 'top';
    const isVertical = legendPosition === 'left' || legendPosition === 'right';
    return {
        orient: isVertical ? 'vertical' : 'horizontal',
        show: true,
        [legendPosition]: exports.LEGEND_EDGE_OFFSET
    };
};
exports.buildLegendConfig = buildLegendConfig;
const normalizeChartData = (chart) => {
    var _a;
    if (!Array.isArray(chart.series) || chart.series.length === 0) {
        throw new Error('Chart response did not include any series data.');
    }
    chart.series.forEach((series, index) => {
        if (!series || !Array.isArray(series.data)) {
            throw new Error(`Series at index ${index} is missing its data array.`);
        }
    });
    const categoriesInput = (_a = chart.options) === null || _a === void 0 ? void 0 : _a.categories;
    if (!Array.isArray(categoriesInput) || categoriesInput.length === 0) {
        throw new Error('All chart types must include an options.categories array.');
    }
    const categories = categoriesInput.map((category, index) => {
        if (category === null || category === undefined) {
            throw new Error(`Category value at index ${index} is invalid.`);
        }
        return String(category);
    });
    const expectedLength = categories.length;
    const sanitizedSeries = chart.series.map((series, seriesIndex) => {
        if (!Array.isArray(series.data)) {
            const label = series.name || `Series ${seriesIndex + 1}`;
            throw new Error(`Series "${label}" is missing its data array.`);
        }
        if (series.data.length !== expectedLength) {
            const label = series.name || `Series ${seriesIndex + 1}`;
            throw new Error(`Series "${label}" must include ${expectedLength} data points to match categories.`);
        }
        const sanitizedData = series.data.map((rawValue, dataIndex) => {
            const value = rawValue;
            if (value === null || value === undefined) {
                return null;
            }
            if (typeof value === 'number' && Number.isFinite(value)) {
                return value;
            }
            if (typeof value === 'string') {
                const trimmed = value.trim();
                if (!trimmed) {
                    return null;
                }
                const numericValue = Number(trimmed);
                if (Number.isFinite(numericValue)) {
                    return numericValue;
                }
            }
            const label = series.name || `Series ${seriesIndex + 1}`;
            const categoryLabel = categories[dataIndex];
            throw new Error(`Series "${label}" has a non-numeric value at category "${categoryLabel}".`);
        });
        return Object.assign(Object.assign({}, series), { data: sanitizedData });
    });
    return {
        categories,
        options: chart.options || {},
        series: sanitizedSeries
    };
};
exports.normalizeChartData = normalizeChartData;
//# sourceMappingURL=chart-utils.js.map